<template>
    <div>
        <template v-if="companyLeaves">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Company Leaves</h1>
                <router-link v-if="companyLeavesCrud" to="addCompanyLeave" class="btn btn-primary float-right active">Add Leaves</router-link>
            </div>
            <table id="leavesTable" class="table" style="width:100%">
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Carry Forward</th>
                        <th>Carry Leaves</th>
                        <th>No. Of Leaves</th>
                        <th>Gender</th>
                        <th>Segmentation</th>
                        <th>Employment Status</th>
                        <th class="text-center">Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-else-if="companyLeaves === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="companyLeaves === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                companyLeaves:null,
                companyLeavesCrud:null,
            };
        },
        mounted() {
          var gThat = this;
            this.$Progress.start();
            this.can('company_leaves|crud_company_leaves').then(result => {
                this.companyLeaves = result.company_leaves;
                this.companyLeavesCrud = result.crud_company_leaves;
            }).then(result => {
                if(this.companyLeaves == true){
                    this.getCompanyLeavesData();
                }
            });
          window.softDelete = function(leaveId){
            gThat.softDelete(leaveId);
          }
        },
        methods: {
            getCompanyLeavesData: function(){
                var that = this;
                $('#leavesTable').DataTable({
                    processing: true,
                    serverSide: true,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                    ajax: {
                        "url": "api/companyLeaves",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                that.$Progress.fail();
                            }else{
                                that.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'title'},
                        {data: 'carry_forward'},
                        {data: 'carry_leaves'},
                        {data: 'no_of_leaves'},
                        {data: 'gender'},
                        {data: 'segmentation'},
                        {data: 'employment_status', render: function(data,type,full){
                            var arr = JSON.parse(full.employment_status);
                            var result = arr.map(function(val) {
                                return val;
                            }).join(', ');
                            return result;
                        }},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/editCompanyLeave/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="" data-original-title="Edit" class="action edit"><i class="fas fa-pencil-alt"></i></a><a href="javascript:void(0);" onClick="window.softDelete('+full['id']+')"  data-toggle="tooltip" data-placement="top" title="Delete" class="action edit"> <i class="fas fa-trash-alt"></i> </a>';
                        }, visible: that.companyLeavesCrud},
                    ],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 6 ]
                    }],
                    "order": [[ 0, "desc" ]],
                });
            },
          softDelete(leaveId) {
            Swal.fire({
              title: 'Are you sure?',
              text: "You want to delete this!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
              if (result.value) {
                axios.post("/api/companyLeaveSoftDelete", {LeaveId: leaveId})
                    .then(res => {
                      if(res.status == 200){
                        this.showToastBox('success','Company Leave deleted successfully!');
                        this.$router.go(this.$router.currentRoute);
                        this.$Progress.finish();
                      }else{
                        this.$Progress.fail();
                        Swal.fire({
                          icon: 'error',
                          title: 'Oops...',
                          text: 'Something went wrong!',
                        })
                      }
                    })
                    .catch(err => {
                      console.log(err);
                      this.$Progress.fail();
                      this.showAlertBox('error','couldnt find requested data');
                    });
              }
            })
          }
        },
        created() {
        }
    }
</script>
